<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Trasladar producto</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item active">Trasladar producto</li>
      </ol>
    </div>
    <div v-if="stateView==0" class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button type="button" class="btn btn-theme" @click="newTransfer()">Nuevo</button>
      </div>
      <div class="card-body">
        <!-- busqueda -->
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <select v-model="critery" class="form-control col-md-6">
                <option value="send">Localidad que envia</option>
                <option value="rece">Localidad que recibe</option>
                <option value="date">Por fecha</option>
              </select>
              <template v-if="critery!='date'">
                <input v-model="search" type="text" class="form-control" placeholder="Ingrese el texto a buscar" @keyup="fetchData(1,search,critery,transportState)">
              </template>
              <template v-else-if="critery=='date'">
                <div class="col-md-6">
                  <div class="form-group">
                    <datepicker :bootstrap-styling="true" :format="customFormatter" :language="es" v-model="search" placeholder="Seleccione fecha"/>
                  </div>
                </div>
              </template>
              <button type="submit" class="btn btn-theme" @click="fetchData(1,search,critery,transportState)"><i class="icon-fa icon-fa-search"/> search</button>
            </div>
            <br>
            <div class="form-group">
              <div class="form-check form-check-inline">
                <input
                  id="inlineRadio1"
                  v-model="transportState"
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value="1"
                  @change="fetchData(1, search, critery, transportState)"
                >
                <label class="form-check-label" for="inlineRadio1">Pendiente</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="inlineRadio2"
                  v-model="transportState"
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value="2"
                  @change="fetchData(1, search, critery, transportState)"
                >
                <label class="form-check-label" for="inlineRadio2">Completos</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="inlineRadio3"
                  v-model="transportState"
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value="3"
                  @change="fetchData(1, search, critery, transportState)"
                >
                <label class="form-check-label" for="inlineRadio2">Incompletos</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="inlineRadio4"
                  v-model.trim="transportState"
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value="0"
                  @change="fetchData(1, search, critery, transportState)"
                >
                <label class="form-check-label" for="inlineRadio2">Cancelados</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="inlineRadio5"
                  v-model.trim="transportState"
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  value="4"
                  @change="fetchData(1, search, critery, transportState)"
                >
                <label class="form-check-label" for="inlineRadio2">Todos</label>
              </div>
            </div>
          </div>
        </div>
        <!-- tabla -->
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>No.</th>
              <th>Envia</th>
              <th>Recibe</th>
              <th>Descripcion</th>
              <th>Empleado</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="transport in transportArray" :key="transport.id">
              <td v-text="transport.ticket_number"/>
              <td v-text="transport.place_send.name"/>
              <td v-text="transport.place_rece.name"/>
              <td v-if="transport.description==null" v-text="'Sin descripción'" />
              <td v-else v-text="transport.description"/>
              <td v-text="transport.employee.person.name"/>
              <td>
                <span v-if="transport.state==0" class="btn btn-danger btn-sm">Cancelado</span>
                <span v-else-if="transport.state==1" class="btn btn-info btn-sm">Pendiente</span>
                <span v-else-if="transport.state==2" class="btn btn-success btn-sm">Completo</span>
                <span v-else-if="transport.state==3" class="btn btn-warning btn-sm">Incompleto</span>
              </td>
              <td v-text="transport.transportDate"/>
              <td>
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group">
                    <router-link v-tooltip.top-center="'Revisar envio'" :to="`/admin/productos/transporte/envio?item=${transport.id}`" class="btn btn-success btn-block"><i class="icon-fa icon-fa-eye"/></router-link>
                    <a/>
                    <button v-tooltip.top-center="'Cancelar envio'" v-if="transport.state==1" class="btn btn-danger btn-block" @click="openModal('cancel', transport)"><i class="icon-fa icon-fa-trash"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>

        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, critery, transportState)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search, critery, transportState)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, critery, transportState)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- MODALES -->

      <sweet-modal
        ref="activate_modal"
        icon="info"
        hide-close-button
        blocking
      >
        {{ modalTitleActivate }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activate_modal.close()"
        >No</button>
        <button
          v-if="typeAction == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="cancelTransport()"
        >Si</button>
      </sweet-modal>
    </div>
    <div v-if="stateView==1" class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button type="button" class="btn btn-theme" @click="closeTransfer()">Cerrar</button>

      </div>
      <div class="card-body">
        <tabs class="tabs-default">
          <tab id="envio" name="Envio">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label>Fecha</label>
                    <datepicker
                      :language="es"
                      :format="format"
                      v-model="transportDate"
                      input-class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label>Localidad que envía</label>
                    <multi-select
                      v-model="placeSend"
                      :allow-empty="false"
                      :show-labels="false"
                      :searchable="true"
                      :options="placeArray"
                      label="name"
                      track-by="id"
                      placeholder="Seleccione una localidad"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label>Localidad que recibe</label>
                    <multi-select
                      v-model="placeRece"
                      :class="{ 'is-invalid': $v.placeRece.$error }"
                      :allow-empty="false"
                      :show-labels="false"
                      :searchable="true"
                      :options="placeArray"
                      label="name"
                      track-by="id"
                      placeholder="Seleccione una localidad"
                    />
                  </div>
                  <div v-if="$v.placeRece.$error">
                    <span v-if="!$v.placeRece.required" class="error">
                      El campo es requerido
                    </span>
                    <span v-else class="error">
                      Las localidades no pueden ser las mismas.
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-2">
                  <div class="form-group">
                    <label>Documento</label>
                    <input
                      value="Envio"
                      class="form-control"
                      disabled
                    >
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Numero de boleta</label>
                    <input v-model="ticketNumber" type="text" class="form-control" readonly>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Productos</label>
                    <multi-select
                      ref="products"
                      v-model="product"
                      :options="products"
                      :allow-empty="false"
                      :show-labels="false"
                      :searchable="true"
                      :loading="isLoadingProducts"
                      :internal-search="false"
                      :custom-label="nameWithCode"
                      label="nameProduct"
                      track-by="idStock"
                      placeholder="Seleccione sus productos"
                      @search-change="searchProducts"
                      @close="addProduct"
                    />
                  </div>
                </div>
                <div class="col-lg-1">
                  <div class="form-group">
                    <label>Agregar</label>
                    <button class="btn btn-success btn-block" @click="addProduct"><i class="icon-fa icon-fa-plus" /></button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Productos</label>
                    <table-component :data="selectProducts" :show-filter="false" table-class="table">
                      <table-column show="code" label="Código" />
                      <table-column show="nameProduct" label="Producto" />
                      <table-column show="stock" label="Existencia">
                        <template slot-scope="row">
                          {{ myquantity(row['stock']) }}
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Cantidad">
                        <template slot-scope="row">
                          <input
                            :class="{ 'is-invalid': selectProducts[getIndex(selectProducts,row['id'])].error===true }"
                            :ref="'quantity-'+getIndex(selectProducts,row['id'])"
                            v-model.number="selectProducts[getIndex(selectProducts,row['id'])].quantity"
                            type="number"
                            class="form-control"
                            @blur="validateQuantity(getIndex(selectProducts,row['id']))"
                          >
                        </template>
                      </table-column>
                      <table-column :sortable="false" :filterable="false" label="Acciones">
                        <template slot-scope="row">
                          <div
                            class="btn-group mr-2"
                            role="group"
                            aria-label="First group">
                            <button class="btn btn-danger" @click="removeProduct(getIndex(selectProducts,row['id']))"><i
                              class="icon-fa icon-fa-trash" />
                              Quitar
                            </button>
                          </div>
                        </template>
                      </table-column>
                    </table-component>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9">
                  <div class="form-group">
                    <label>Comentario</label>
                    <input
                      ref="description"
                      v-model="description"
                      class="form-control"
                      placeholder="Comentario sobre el envio"
                    >
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <button
                      ref="buttonSave"
                      slot="button"
                      class="btn btn-block btn-theme ladda-button"
                      data-style="expand-right"
                      @click="saveTransport"
                      @keyup.enter="saveTransport"
                    >Guardar traslado</button>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, not, sameAs } from 'vuelidate/lib/validators'
import ladda from 'ladda'
import { Tabs, Tab } from 'vue-tabs-component'
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'
import Multiselect from 'vue-multiselect'
import { TableComponent, TableColumn } from 'vue-table-component'
import { xelacode } from '../../../helpers/xelacode'
import moment from 'moment'

export default {
  components: {
    'tabs': Tabs,
    'tab': Tab,
    Datepicker,
    'multi-select': Multiselect,
    TableComponent,
    TableColumn,
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      transportDate: new Date().toISOString().slice(0, 10),
      format: 'dd/MM/yyyy',
      en: en,
      es: es,
      placeSend: [],
      placeRece: [],
      placeArray: [],
      product: '',
      products: [],
      isLoadingProducts: false,
      description: '',
      ticketNumber: 0,

      selectProducts: [],
      typeAction: 1,
      modalTitleActivate: '',
      transportState: 4,
      stateView: 0,
      transportArray: [],

      modalTitle: '',
      id: 0,
      codigo: '',
      nombreProducto: '',
      productArray: [],
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      critery: 'send',
      search: ''
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.search, this.critery, this.transportState)
    this.getUser()
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations: {
    placeRece: {
      required,
      isNotsameAsPlaceSend: not(sameAs('placeSend'))
    }
  },
  methods: {
    changePage (page, search, critery, state) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, search, critery, state)
    },
    async fetchData (page, search, critery, state) {
      let me = this
      var url
      if (this.critery === 'date') {
        url = `/api/admin/transport/get?page=${page}&search=${this.customFormatter(search)}&critery=${critery}&state=${state}`
      } else {
        url = `/api/admin/transport/get?page=${page}&search=${search}&critery=${critery}&state=${state}`
      }
      const response = await axios.get(
        url
      )
        .then(function (response) {
          var respuesta = response.data
          me.transportArray = respuesta.transports.data
          me.pagination = respuesta.pagination
          // console.log(response)
          // console.log(me.transportArray)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    newTransfer () {
      let me = this
      me.getTicket()
      me.stateView = 1
    },
    closeTransfer () {
      this.$v.$reset()
      this.stateView = 0
      this.placeRece = []
      this.selectProducts = []
      this.description = ''
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.transportState)
    },
    getTicket () {
      let me = this
      axios.get('/api/admin/transport/getTicket')
        .then(function (response) {
          // var respuesta = response
          me.ticketNumber = response.data.ticket
          // console.log(response.data.ticket)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    searchProducts (filter) {
      let me = this
      var url = `/api/admin/transport/getProducts?place=${this.placeSend.id}&filter=${filter}`
      this.isLoadingProducts = true
      axios.get(url).then(function (response) {
        me.products = response.data.data
        me.isLoadingProducts = false
      })
        .catch(function (error) {
          console.log(error)
          me.isLoadingProducts = false
        })
    },
    nameWithCode ({ nameProduct, code }) {
      return `${code} | ${nameProduct}`
    },
    addProduct () {
      if (typeof (this.selectProducts.find(x => x.id === this.product.id)) !== 'undefined') {
        toastr.error('El producto ya esta agregado', 'Error')
        this.product = ''
        // return
      } else if (this.product === [] || this.product === '' || this.product === null) {
        // toastr.error('Seleccione un producto', 'Error')
        this.product = ''
        // return
      } else {
        toastr.success('Producto agregado correctamente', 'Listo')
        this.selectProducts.push(this.product)
        this.product = ''
      }
      // this.calculateSubtotal(this.selectProducts.length - 1)
      // this.changeRefVue('products')
    },
    removeProduct (item) {
      this.selectProducts.splice(item, 1)
      toastr.success('Producto eliminado correctamente', 'Listo')
    },
    getIndex (list, id) {
      return list.findIndex((e) => e.id == id)
    },
    myquantity (value) {
      return xelacode.quantity(value)
    },
    validateQuantity (item) {
      if (typeof (this.selectProducts[item].quantity) !== 'undefined') {
        if (this.selectProducts[item].quantity > this.selectProducts[item].stock) {
          this.selectProducts[item].quantity = this.selectProducts[item].stock
          toastr.error('Existencia insuficiente', 'Error')
          // this.refMultiple('quantity', item);
        } else if (this.selectProducts[item].quantity < 1) {
          this.selectProducts[item].quantity = 1
          toastr.error('La cantidad debe ser al menos 1', 'Error')
          // this.refMultiple('quantity', item)
        }
        // this.calculateSubtotal(item);
      }
    },
    saveTransport () {
      this.$v.$touch()
      let me = this
      var l = ladda.create(document.querySelector('.ladda-button'))
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        if (this.selectProducts.length < 1) {
          toastr.error('No hay productos agregados', 'Error')
          return
        }
        l.start()
        axios.post('/api/admin/transport/newTransport', {
          transportDate: me.transportDate,
          description: me.description,
          ticketNumber: me.ticketNumber,
          placeSend: me.placeSend.id,
          placeRece: me.placeRece.id,
          products: JSON.stringify(me.selectProducts)
        }).then((response) => {
          // me.$router.push({name:'VentaLista',
          //                 params:{
          //                   message:response.data.message
          //                 }
          // }
          // )
          toastr.success(response.data.message, 'Listo')
          l.stop()
          me.closeTransfer()
        }).catch((error) => {
          l.stop()
          console.log(error)
          toastr.error(error.response.data.message, 'Error')
        })
      }
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'cancel': {
          me.$refs.activate_modal.open()
          this.modalTitleActivate = '¿Desea cancelar el envio?'
          this.id = data['id']
          this.typeAction = 3
          break
        }
      }
    },
    closeModal () {
      // this.$refs.modal_account.close()
      this.$refs.activate_modal.close()
      this.modalTitleActivate = ''
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.transportState)
    },
    getUser () {
      let me = this;
      axios.get('/api/sale/getUser')
        .then((response) => {
          me.user = response.data
          // me.getSetting('Ventas', 'Permiso para permitir hacer descuentos a usuarios en una venta', me.user.id);
          me.selectPlace(me.user.placeId)
          // me.defaultProducts(me.user.placeId);
        }).catch((error) => {
          console.log(error)
        })
    },
    selectPlace (id) {
      let me = this
      var url = '/api/admin/place/getSelect'
      axios
        .get(url)
        .then(function (response) {
          var respuesta = response.data
          me.placeArray = respuesta.place
          me.placeSend = me.placeArray.find(x => x.id === id)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    cancelTransport () {
      let me = this
      var url = '/api/admin/transport/cancelShipment'
      axios
        .patch(url, {
          id: this.id
        })
        .then(function (response) {
          // console.log(response)
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/transport/Transport.vue